import { Popover, Transition } from '@headlessui/react';
import moment from 'moment';
import { memo } from 'react';
import TooltipV2 from '../TooltipV2';

function TitlePopup({
  onUpdate,
  title,
  onTitleChange,
  recordingDate,
  onRecordingDateChange,
  disableTitlePopup
}: {
  onUpdate: () => void;
  title?: string;
  onTitleChange: (e: React.ChangeEvent) => void;
  recordingDate?: string;
  onRecordingDateChange?: (e: React.ChangeEvent) => void;
  disableTitlePopup?: boolean;
}) {
  const maxDate = moment().format('YYYY-MM-DD');

  return (
    <Popover className="relative min-w-0" data-testid="content-title-popup">
      <TooltipV2
        key="recording-title-tooltip"
        tooltipId="recording-title-tooltip"
        tooltipElement={
          <Popover.Button
            className="max-w-[294px] truncate rounded-lg px-2 py-0.5 text-base font-medium leading-tight text-slate-900 hover:bg-ghost-hover"
            disabled={disableTitlePopup}
          >
            {title}
          </Popover.Button>
        }
        tooltipContent={title || ''}
        size="xsmall"
        place="bottom"
      />

      <Transition
        enter="transition duration-150 ease-out"
        enterFrom="transform scale-[0.98] opacity-0"
        enterTo="transform scale-1 opacity-100"
        leave="transition duration-100 ease-out"
        leaveFrom="transform scale-1 opacity-100"
        leaveTo="transform scale-[0.98] opacity-0"
        afterLeave={onUpdate}
      >
        <Popover.Panel className="absolute left-0 top-full z-[110] mt-1 w-[23rem] rounded-lg border bg-white p-2 shadow-lg">
          <input
            type="text"
            data-testid="title-input"
            className="w-full rounded-lg border bg-slate-50 px-2.5 py-2 text-sm"
            value={title}
            required
            onChange={onTitleChange}
          />
          {!!onRecordingDateChange && (
            <>
              <div className="pt-3 text-xs text-slate-500">Recording Date</div>
              <input
                type="date"
                data-testid="recording-date-input"
                className="w-full rounded-lg border bg-slate-50 px-2.5 py-2 pt-1 text-sm"
                value={recordingDate}
                required
                max={maxDate}
                onChange={onRecordingDateChange}
              />
            </>
          )}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}

export default memo(TitlePopup);
